import React from 'react';
import Icon from './Icon';

const SearchIcon = (props) => (
    <Icon {...props}>
        <path
            d="M19 11A8 8 0 1 1 3 11A8 8 0 0 1 19 11ZM21 21L16.65 16.65"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default SearchIcon;